export const RECONCILIATIONS_RESET_STATE = 'RECONCILIATIONS_RESET_STATE';
export const RECONCILIATIONS_CURRENT_ITEM = 'RECONCILIATIONS_CURRENT_ITEM';

export const RECONCILIATIONS_REQUEST_LOADING = 'RECONCILIATIONS_REQUEST_LOADING';
export const RECONCILIATIONS_REQUEST_SUCCESS = 'RECONCILIATIONS_REQUEST_SUCCESS';
export const RECONCILIATIONS_REQUEST_FAILED = 'RECONCILIATIONS_REQUEST_FAILED';

export const RECONCILIATIONS_CURRENT_ACTION = 'RECONCILIATIONS_CURRENT_ACTION';
export const RECONCILIATIONS_RESET_ACTION = 'RECONCILIATIONS_RESET_ACTION';